import axios from "axios";
const API_URL =  process.env.REACT_APP_API_URL;


 const fetcher = async (url) => {
    const { data } = await axios.get(API_URL+url);
  
    return data;
  };

 
  const post = async (url,body) => {
    const fullUrl = API_URL + url;
    const resp = await axios.post(fullUrl, body);
  
    return resp;
  };


const exp = {fetcher, post}
export default exp